import * as materials from "@lts/materials/legacy/legacy-gradient";
export { materials };
export default materials;
